import React from 'react';

const GiftsFields = ({
  oldData, 
  setGift,
  setGiftTime,
  setGiftSubject,
  setGiftType,
  setGiftAmount
}) => {

  return (
    <>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Дарит подарки (Да/Нет)
      </div>

      <input
          className='main-form__input main-form__input-full'
          defaultChecked={oldData.gift}
          type='checkbox'
          onChange={e => { setGift() }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Время, потраченное на подарок
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.gift_time}
          placeholder='Время, потраченное на подарок'
          onChange={e => { setGiftTime(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Тема подарка
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.gift_subject}
          placeholder='Тема подарка'
          onChange={e => { setGiftSubject(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Тип подарка (физический/денежный сертификат)
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.gift_type}
          placeholder='Тип подарка'
          onChange={e => { setGiftType(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Сумма подарка
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.gift_amount}
          type='number'
          placeholder='Сумма подарка'
          onChange={e => { setGiftAmount(e) }}
      />

    </>
  );
};

export default GiftsFields;